import * as _firebase from "firebase/app";
import "firebase/database";
import uuid from "uuid-random";

const firebase = _firebase.default;
export default class {
  private subscriptions: {
    [id: string]: {
      path: string;
      callback: (snapshot: _firebase.default.database.DataSnapshot) => void;
    };
  };
  constructor() {
    this.subscriptions = {};
  }

  subscribe = async (
    channel: string,
    callback: (channel: string, message: any) => void
  ): Promise<string> => {
    const id = uuid();
    const path = `_pusher/${channel.replace(/\./g, ",")}`;
    this.subscriptions[id] = {
      path,
      callback: (snapshot: _firebase.default.database.DataSnapshot) => {
        const v = snapshot.val();
        callback(channel, v);
      }
    };
    const database = firebase.database();
    database.ref(path).on("value", this.subscriptions[id].callback);
    return id;
  };

  unsubscribe = async (id: string) => {
    if (!this.subscriptions[id]) return;
    const { path, callback } = this.subscriptions[id];
    const database = firebase.database();
    database.ref(path).off("value", callback);
    delete this.subscriptions[id];
  };
}
